import React, { Component } from 'react'
import {
  Avatar,
  Layout,
  Typography,
  Button,
  Space,
  Message,
  Empty,
  Upload,
  Card,
  Modal,
  Divider,
} from '@arco-design/web-react'
import { IconDownload, IconDelete, IconPlus } from '@arco-design/web-react/icon'
import Emptydata_img from 'asserts/Emptydata_img.svg'
import Generating_img from 'asserts/Generating_img.gif'
import errorIcon from 'asserts/error_icon.svg'
import docx_icon from 'asserts/docx_icon.png'
import pdf_icon from 'asserts/pdf_icon.png'
import { shareAppApi } from 'api/apis'
import upload from 'api/uploads'
import { debounce, b2ValueUnit } from 'common/utils'
import { sourceCancelClass } from 'api/cancel-request'
import $ from 'jquery'
import '../../common/style/myapp/semanticprototype.scss'
const Sider = Layout.Sider
const Content = Layout.Content

// 封装组件
class SemanticPrototype extends Component {
  constructor(props) {
    super(props)
    this.state = {
      share_id: localStorage.getItem('share_ids'),
      ParagraphContinuation: [],
      ContinuationLoding: false,
      record: JSON.parse(localStorage.getItem('shareRecord')),
      requestMsg: '',
      requestMsgText: '您还未上传图片',
      attachment: [],
      fileList: [],
      visible: false,
      visibleimg: null,
      loading: false,
      setChangeAbatchTime: '',
      setRequestTime: '',
    }
    this.isputapp = debounce(this.isputapp, 1000)
  }
  componentDidMount() {
    this.getApiInfo()
  }
  componentWillUnmount() {
    localStorage.removeItem('props')
    clearTimeout(this.state.setRequestTime)
    clearTimeout(this.state.setChangeAbatchTime)
    sourceCancelClass()
  }
  handleResize = () => {
    // var winHeight = 0;
    // if (window.innerHeight) {
    //   winHeight = window.innerHeight;
    // } else if (document.body && document.body.clientHeight) {
    //   winHeight = document.body.clientHeight;
    // }
    // if (document.documentElement && document.documentElement.clientHeight) {
    //   winHeight = document.documentElement.clientHeight;
    // }
    // let layoutHeaders_h = document.getElementById("layoutHeaders").clientHeight;
    // if (layoutHeaders_h > winHeight) {
    //   layoutHeaders_h = 64;
    // }
    // let height =
    //   winHeight -
    //   layoutHeaders_h -
    //   document.getElementById("renderHeaders").clientHeight -
    //   32 -
    //   45;
    // document.getElementById("layout_id").style.height = height + "px";
    // if (document.getElementById("continuation")) {
    //   let height2 =
    //     document.getElementById("result").clientHeight -
    //     document.getElementById("result_title").clientHeight -
    //     34;
    //   document.getElementById("continuation").style.height =
    //     height2 - 30 + "px";
    //   this.initSlider();
    // }
  }
  initSlider() {
    var screenWidth = $('.Continuation-item').width() //浏览器页面的宽度
    var height = screenWidth * 0.72 //14.2
    this.setState({
      height: height,
    })
  }
  getApiInfo() {
    let list = this.state.record
    // document.title = list.app_name
    if (list.type === 0) {
      let fileList = [
        {
          status: 'done',
          percent: 100,
          uid: '16497711382130',
          url: 'https://test.saas.file.yoo-ai.com/20220331/f2022033-1150-305e-4e58-f4fe3800f9bc.png',
          name: '62f61fa94de3669be8897cdec744221a51866920ffa40a4f1ca2491eabe70ece.png',
          response: {
            fileKey: 'f2022041-2214-5364-711a-af797b1f8898',
            fileName:
              '62f61fa94de3669be8897cdec744221a51866920ffa40a4f1ca2491eabe70ece.png',
            url: 'https://test.saas.file.yoo-ai.com/20220331/f2022033-1150-305e-4e58-f4fe3800f9bc.png',
            time: 1649771136,
          },
        },
      ]
      this.setState({
        fileList: fileList,
        attachment: ['f2022041-2214-5364-711a-af797b1f8898'],
      })
      this.ChangeAbatch('start')
    }

    //console.log(res.data, "api服务");
  }

  handleUpload(option) {
    upload(option)
  }
  setFile(fileList, file) {
    this.setState({
      fileList: fileList,
    })
    if (file.status === 'done') {
      let key = []
      let fileList = this.state.fileList
      fileList.map((item, index) => {
        key.push(item.response.fileKey)
      })
      this.setState({
        attachment: key,
        fileList: fileList,
      })
    }
  }
  beforeUpload(file) {
    var AllImgExt = '.jpg|.pdf|.png|.docx|.doc|'
    var extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase() //（把路径中的所有字母全部转换为小写）
    if (AllImgExt.indexOf(extName + '|') === -1) {
      let ErrMsg =
        '该文件类型不允许上传。请上传 .jpg、.pdf、.png 、.docx、.doc类型的文件，当前文件类型为' +
        extName
      Message.error(ErrMsg)
      return false
    }
    const isLt10M = !(
      b2ValueUnit(file.size)[1] === 'B' ||
      b2ValueUnit(file.size)[1] === 'KB' ||
      (b2ValueUnit(file.size)[1] === 'MB' && b2ValueUnit(file.size)[0] <= 1)
    )
    return new Promise((resolve, reject) => {
      if (isLt10M) {
        Message.error('上传文件不能大于1M')
        reject()
      } else {
        resolve()
      }
    })
  }
  setRequest() {
    clearTimeout(this.state.setRequestTime)
    clearTimeout(this.state.setChangeAbatchTime)
    if (this.state.attachment.length === 0) {
      this.setState({
        ParagraphContinuation: [],
        ContinuationLoding: false,
        requestMsg: '',
        requestMsgText: '您还未上传图片',
      })
    } else {
      let params = {
        app_id: this.state.record.app_id,
        fileKey: JSON.stringify(this.state.attachment),
        share_id: this.state.share_id,
      }
      const { ParagraphContinuation } = this.state
      this.setState({
        loading: true,
      })
      shareAppApi(params).then((res) => {
        if (res.code === 200) {
          let list = res.data
          this.setState({
            ParagraphContinuation: ParagraphContinuation.concat(list),
            ContinuationLoding: false,
            requestMsg: '',
          })

          if (this.state.ParagraphContinuation.length % 16 !== 0) {
            this.state.setRequestTime = setTimeout(() => {
              this.setRequest()
            }, 4000)
          } else {
            this.setState({
              loading: false,
            })
            // setTimeout(() => {
            //     this.handleResize();
            // }, 100)
          }
          if (
            this.state.ParagraphContinuation.length === 1 &&
            list.length > 0
          ) {
            setTimeout(() => {
              this.handleResize()
            }, 100)
          }
        } else if (res.code === 400 || res.code === 3003 || res.code === 204) {
          this.setState({
            ContinuationLoding: false,
            requestMsg: '',
            loading: false,
          })
          if (ParagraphContinuation.length > 0) {
            Notification.warning({ content: res.msg })
          } else {
            this.setState({
              ParagraphContinuation: [],
              requestMsgText: res.msg,
            })
          }
        } else {
          this.setState({
            ContinuationLoding: false,
            requestMsg: '',
            loading: false,
          })
          if (ParagraphContinuation.length > 0) {
            Notification.warning({ content: res.msg })
          } else {
            this.setState({
              ParagraphContinuation: [],
              requestMsg: 'error',
              requestMsgText: res.msg,
            })
          }
        }
      })
    }
  }
  ChangeAbatch(type) {
    sourceCancelClass()
    clearTimeout(this.state.setRequestTime)
    clearTimeout(this.state.setChangeAbatchTime)
    if (type === 'start') {
      this.setState({
        ParagraphContinuation: [],
        loading: false,
        ContinuationLoding: true,
        requestMsg: '',
      })
    } else {
      this.setState({
        loading: true,
        requestMsg: '',
      })
    }
    this.state.setChangeAbatchTime = setTimeout(() => {
      this.setRequest()
    }, 1000)
  }
  setdownload(visible) {
    this.setState({
      visible: visible,
    })
  }
  opendownload(item) {
    this.setdownload(true)
    this.setState({
      visibleimg: item,
    })
  }
  getUrlBase64() {
    var url = this.state.visibleimg // 获取图片地址
    // var a = document.createElement('a');          // 创建一个a节点插入的document
    // var event = new MouseEvent('click')           // 模拟鼠标click点击事件
    // a.download = '样机图'                  // 设置a节点的download属性值
    // a.target = "_blank"
    // a.href = url;                                 // 将图片的src赋值给a节点的href
    // a.dispatchEvent(event)
    fetch(url)
      .then(async (res) => await res.blob())
      .then((blob) => {
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = URL.createObjectURL(blob)
        a.download = '样机图'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      })
  }
  //判断文件是pdf
  pdfType(result2, file) {
    if (result2) {
      let type = file.originFile.type
      // var index = url.lastIndexOf("\/");
      // url = url.substring(index + 1, url.length);
      //获取最后一个.的位置
      // var index = result2.lastIndexOf(".");
      // //获取后缀
      // var ext = result2.substr(index + 1);
      if (
        [
          'application/pdf',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/msword',
        ].indexOf(type.toLowerCase()) === -1
      ) {
        return false
      } else {
        if (
          type ===
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
          type === 'application/msword'
        ) {
          return 'docx'
        } else {
          return 'pdf'
        }
      }
    }
  }
  renderUploadList = (filesList, props) => {
    return (
      <div className="rowStart" style={{ width: '100%' }}>
        {filesList.map((file) => {
          const url =
            file.url ||
            (file.originFile ? URL.createObjectURL(file.originFile) : '')
          return (
            <Card
              className="upload-demo-list"
              key={file.uid}
              hoverable
              bodyStyle={{ padding: '4px 8px' }}
              cover={
                <img
                  className={`${this.pdfType(url, file) ? 'fileType' : ''}`}
                  src={
                    this.pdfType(url, file) === 'pdf'
                      ? pdf_icon
                      : this.pdfType(url, file) === 'docx'
                      ? docx_icon
                      : url
                  }
                  style={{ height: '100%' }}
                  alt=""
                />
              }
              actions={[
                <div className="file-Delete">
                  <IconDelete
                    onClick={() => {
                      props.onRemove(file)
                    }}
                  />
                </div>,
              ]}
            ></Card>
          )
        })}
      </div>
    )
  }

  render() {
    const {
      loading,
      visibleimg,
      fileList,
      ParagraphContinuation,
      ContinuationLoding,

      requestMsg,
      requestMsgText,
    } = this.state
    return (
      <div className="semanticprototype">
        <Layout className="semanticprototype-Layout" id="layout_id">
          <Content>
            <div className="experience-result" id="result">
              <div id="result_title" className="rowSpaceBetween result_title">
                <Typography>生成结果</Typography>
                <Typography.Paragraph className="result-remarks">
                  (内容基于韦尼克AI创作引擎生成，仅供参考)
                </Typography.Paragraph>
              </div>
              {ParagraphContinuation.length > 0 || ContinuationLoding ? (
                <div className="Paragraph-generate">
                  {ContinuationLoding ? (
                    <Empty
                      className="Continuation-loding"
                      icon={<img src={Generating_img} />}
                      description={
                        <Typography
                          style={{
                            color: '#4e5969',
                            marginTop: 21,
                            fontSize: 16,
                          }}
                        >
                          正在生成中...
                        </Typography>
                      }
                    />
                  ) : (
                    <div className="Continuation-result" id="continuation">
                      <div className="Continuation-list">
                        {ParagraphContinuation.map((item, index) => {
                          return (
                            <div
                              className="Continuation-item"
                              key={index}
                              onClick={this.opendownload.bind(this, item)}
                            >
                              <div className="Continuation-img">
                                <Avatar shape="square">
                                  <img alt="avatar" key={index} src={item} />
                                </Avatar>
                                {/* <Image key={index} src={item} /> */}
                              </div>
                            </div>
                          )
                        })}
                      </div>
                      {loading ? (
                        <Empty
                          className="list-loding"
                          icon={<img src={Generating_img} />}
                          description={
                            <Typography
                              style={{
                                color: '#4e5969',
                                marginTop: 21,
                                fontSize: 16,
                              }}
                            >
                              正在生成中...
                            </Typography>
                          }
                        />
                      ) : (
                        <Button
                          icon={<IconPlus />}
                          id="iconSync"
                          className="IconSync-btn custom-White-border-button"
                          onClick={this.ChangeAbatch.bind(this)}
                        >
                          生成更多
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              ) : requestMsg === 'error' ? (
                <Empty
                  className="Continuation-Empty Empty-error"
                  imgSrc={errorIcon}
                  description={
                    <Space direction="vertical">
                      <Typography
                        style={{
                          color: '#4e5969',
                          marginTop: 30,
                          fontSize: 16,
                        }}
                      >
                        抱歉，服务器生成错误
                      </Typography>
                      <Typography style={{ color: '#4e5969', fontSize: 16 }}>
                        可尝试
                        <span
                          style={{ color: '#406EFF', cursor: 'pointer' }}
                          onClick={this.ChangeAbatch.bind(this, 'start')}
                        >
                          {' '}
                          重新生成
                        </span>
                      </Typography>
                    </Space>
                  }
                />
              ) : (
                <Empty
                  className="Continuation-Empty Empty-none"
                  imgSrc={Emptydata_img}
                  description={
                    <Space direction="vertical">
                      <Typography
                        style={{
                          color: '#4e5969',
                          marginTop: 30,
                          fontSize: 16,
                        }}
                      >
                        暂无生成结果
                      </Typography>
                      <Typography style={{ color: '#4e5969', fontSize: 16 }}>
                        {requestMsgText}
                      </Typography>
                    </Space>
                  }
                />
              )}
            </div>
          </Content>
          <Sider className="Sider-left">
            <div className="Sider-left-configure columnSpaceBetween">
              <div className="Sider-left-w">
                <div className="semanticprototype-title">样机配置</div>
                <div className="Upload-pictures-title">上传图片</div>
                <div className="upload-demo-trigger">
                  <Upload
                    drag
                    multiple
                    accept=".PDF,.JPG,.PNG,.docx,.doc"
                    fileList={fileList}
                    renderUploadList={this.renderUploadList}
                    limit={3}
                    onChange={this.setFile.bind(this)}
                    customRequest={(option) => {
                      this.handleUpload(option)
                    }}
                    beforeUpload={this.beforeUpload.bind(this)}
                    onExceedLimit={() => {
                      Message.warning('超过上传数量限制！最多上传3个')
                    }}
                  >
                    <div className="rowCenter trigger">
                      <Space direction="vertical">
                        <span className="iconfont icon-icon_chuangjian_24"></span>
                        <div>上传图片</div>
                      </Space>
                    </div>
                  </Upload>
                </div>
                <div className="Upload-pictures-tip">
                  （仅支持 PDF、docx、doc、JPG 和 PNG 格式，最大文件尺寸1MB）
                </div>
              </div>
              <div className="Upload-pictures-bottom">
                <Divider />
                <Button
                  type="primary"
                  className="Start-generation"
                  loading={false}
                  onClick={this.ChangeAbatch.bind(this, 'start')}
                >
                  开始生成
                </Button>
              </div>
            </div>
          </Sider>
        </Layout>
        <Modal
          style={{
            width: 667,
          }}
          onCancel={() => this.setdownload(false)}
          className="custom-modal-download-sem"
          title={null}
          visible={this.state.visible}
          autoFocus={false}
          footer={
            <>
              <Button
                type="primary"
                className="download-btn"
                onClick={this.getUrlBase64.bind(this)}
              >
                <IconDownload />
                立即下载
              </Button>
            </>
          }
        >
          <div className="custom-modal-download-content">
            {visibleimg ? <img src={visibleimg} /> : ''}
          </div>
        </Modal>
      </div>
    )
  }
}
export default SemanticPrototype
